
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/integrating-teamsreminder-workflow-tools-guide",
      function () {
        return require("private-next-pages/article/integrating-teamsreminder-workflow-tools-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/integrating-teamsreminder-workflow-tools-guide"])
      });
    }
  